const DOJO_OTP_VALID = {
    VALID: 'valid',
    INVALID: 'invalid',
    NOT_CHANGED: 'not_changed',
}

export default DOJO_OTP_VALID
